import React from 'react';
import { Row, Col, TextInput, Heading, themes, Radio, RadioGroup, } from '@digitools/honest-react';
import useTranslate from '../../../hooks/useTranslate';
import useCliDataContext from '../hooks/useCliDataContext';
import { Scope, useFormState } from 'informed';
import useValidPhone from '../../../hooks/fieldValidation/useValidPhone';
import { PreferredContactInformationText } from '../constants/PreferredContactInformationText';
import useExperience from '../../../hooks/useExperience';
import { Experience } from 'src/types/Experience';
import { validateEmail } from '../utils/validationUtils';
import { BorderLessGrayBox } from 'src/components/Formatting/StyledComponents';
const phoneMask = (value) => {
    if (value) {
        var numbers = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (numbers) {
            return !numbers[2] ? numbers[1] : '(' + numbers[1] + ') ' + numbers[2] + (numbers[3] ? '-' + numbers[3] : '');
        }
    }
};
/**
 * Section of fields for residential information, for use within a <Form>
 */
const PreferredContactInformation = () => {
    const { t } = useTranslate();
    const { claimantData } = useCliDataContext();
    const { values } = useFormState();
    const { experience } = useExperience();
    const validatePhone = useValidPhone();
    const validateFaxRequired = useValidPhone();
    //@ts-ignore
    const isEmailRequired = !!(experience === Experience.EMPLOYEE || values && values.claimantData && values.claimantData['selectedpreferredmethod'] === 'E');
    //@ts-ignore
    const isFaxRequired = !!(values && values.claimantData && values.claimantData['selectedpreferredmethod'] === 'F');
    const isPhoneRequired = experience === Experience.EMPLOYEE;
    return (<div data-testid='preferred-contact-information' style={{ marginTop: '1rem', marginBottom: '1rem' }}>
      <BorderLessGrayBox>
        <Heading elemType='h3' elemStyle='h4'>{t(PreferredContactInformationText.heading)}</Heading>
      </BorderLessGrayBox>
      {/* @ts-ignore */}
      <Scope scope='claimantData'>
        <Row>
          <Col md={6} xs={12}>
            <TextInput aria-required={isPhoneRequired} id='phoneInput' data-private={true} data-testid='phone' required={isPhoneRequired} validate={validatePhone} validateOnChange={true} validateOnBlur={true} label={isPhoneRequired ? t(PreferredContactInformationText.phone) : t(PreferredContactInformationText.phoneOptional)} aria-label={isPhoneRequired ? t(PreferredContactInformationText.phone) : t(PreferredContactInformationText.phoneOptional)} field={'phone'} 
    //@ts-ignore //FIXME: type error
    mask={phoneMask} initialValue={claimantData && claimantData.phone}/>
          </Col>
          <Col md={6} xs={12}>
              <TextInput aria-required={!!isEmailRequired} data-private={true} data-testid='email' label={isEmailRequired ? t(PreferredContactInformationText.email) : t(PreferredContactInformationText.emailOptional)} field={'email'} required={isEmailRequired} validate={(value) => validateEmail(value, PreferredContactInformationText.email)} validateOnChange={true} validateOnBlur={true} initialValue={claimantData && claimantData.email}/>
          </Col>
          
        </Row>
        <Row>
          <Col md={6} xs={12}>
            <RadioGroup isHorizontal={true} isRequired={true} label={t(PreferredContactInformationText.preferredContactLabel)} semanticLabel={t(PreferredContactInformationText.preferredContactShortLabel)} field={'selectedpreferredmethod'} theme={themes.rebrand} legendStyles={{ marginBottom: '.75rem' }} validateOnBlur={true} validateOnChange={true} required={true} initialValue={claimantData && claimantData.selectedpreferredmethod || experience === Experience.EMPLOYEE && 'E' || experience === Experience.EMPLOYER && 'M'}>
                <Radio data-testid={'pref-email'} name={'selectedpreferredmethod'} id={'selectedpreferredmethod_email'} label={'Email'} value={'E'}/>
                <Radio data-testid={'pref-fax'} name={'selectedpreferredmethod'} id="selectedpreferredmethod_fax" label={'Fax'} value={'F'}/>
                <Radio data-testid={'pref-mail'} name={'selectedpreferredmethod'} id="selectedpreferredmethod_mail" label={'Mail'} value={'M'} containerStyle={{ display: 'inline', justifyContent: 'left', marginRight: '.5rem' }}/>
            </RadioGroup>
          </Col>
          {isFaxRequired && <Col md={6} xs={12} style={{ marginTop: '1.1rem' }}>
            <TextInput required={true} data-testid='fax' validate={validateFaxRequired} validateOnChange={true} validateOnBlur={true} label={t(PreferredContactInformationText.fax)} aria-label={t(PreferredContactInformationText.fax)} field={'claimantpreferredfax'} 
        //@ts-ignore //FIXME: type error
        mask={phoneMask} initialValue={claimantData && claimantData.claimantpreferredfax}/>
          </Col>}
        </Row>
      </Scope>
    </div>);
};
export default PreferredContactInformation;
